import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { RenterForm } from '@core/components/abstract/renter-form';
import { AppStateService } from '@core/services/state.service';
import { MatSlideToggleChange } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { E } from '@angular/cdk/keycodes';

@Component({
  selector: 'renter-identification-document',
  templateUrl: './renter-identification-document.component.html',
  styleUrls: ['./renter-identification-document.component.scss']
})
export class RenterIdentificationDocument implements OnInit, AfterViewInit, OnDestroy {
  
  nowDate = new Date();
  @Input() isFormDisabled: boolean = false;

  constructor(
    private renterFormService: RenterRegFormService ,
    private appStateService: AppStateService,
    
  ) {
   
    
  }
  ngOnDestroy(): void {
    this.appStateServiceSharedState$.unsubscribe();
  }
  ngAfterViewInit(): void {
  }

 
  isIdCardSelected = false;
  onToggleChange(event: MatSlideToggleChange) {
    this.isIdCardSelected = event.checked;
    this.appStateService.updateState(event.checked);

  }

  appStateServiceSharedState$: Subscription;
  ngOnInit() {

    this.appStateServiceSharedState$ = this.appStateService.sharedState$.subscribe((response) => {
      if (response != null) {
        this.isIdCardSelected = response;
      }
    });
   }

}
